module.exports = __webpack_public_path__ + "img/image_01.ea9dc4e3.png";